import { Field } from "components";

type Props = {
  onPasswordChange: (password: string) => void;
  onPasswordValid: (isValid: boolean) => void;
};

export const Fields = ({ onPasswordChange, onPasswordValid }: Props) => {
  return (
    <>
      <Field.Password
        onPasswordChange={onPasswordChange}
        onPasswordValid={onPasswordValid}
      />
    </>
  );
};
